import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, InputSignal } from '@angular/core';
import { ScrollService } from 'src/app/services/scroll.service';

@Component({
  selector: 'app-nav-button',
  standalone: true,
  imports: [],
  templateUrl: './nav-button.component.html',
  styleUrls: ['./nav-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavButtonComponent {
  public label: InputSignal<string> = input.required();
  public iconName: InputSignal<string> = input.required();
  public active: InputSignal<boolean> = input(false);
  
  private _scrollService = inject(ScrollService);
  
  protected isScrolled =  this._scrollService.isScrolled;
}
